module.exports = __webpack_public_path__ + "img/learn-more-illu-storage.223030d6.svg";